import formatDistanceToNow from 'date-fns/formatDistanceToNow'
import toDate, { dateParamType } from '~/utils/gcxDates/toDate'

type distanceFromNowInWordsType = (date: dateParamType) => string

const distanceFromNowInWords: distanceFromNowInWordsType = (dateProp) => {
  const date = toDate(dateProp)
  const result = formatDistanceToNow(date)
  return `${result.replace('about ', '')} ago`
}

export default distanceFromNowInWords
